const PT_TZ = "America/Los_Angeles"
const AUCTION_END_HOUR = 19
const AUCTION_END_MINUTE = 30
const MIN_DURATION_MS = 7 * 24 * 60 * 60 * 1000

function isPSTDST(date: Date): boolean {
  const y = date.getUTCFullYear()
  const marchSecondSunday = new Date(Date.UTC(y, 2, 1, 12, 0, 0))
  let day = marchSecondSunday.getUTCDay()
  marchSecondSunday.setUTCDate(1 + (day === 0 ? 7 : 14 - day))
  const novFirstSunday = new Date(Date.UTC(y, 10, 1, 12, 0, 0))
  day = novFirstSunday.getUTCDay()
  novFirstSunday.setUTCDate(1 + (day === 0 ? 7 : 14 - day))
  return date >= marchSecondSunday && date < novFirstSunday
}

function nextSunday730PtAfter(from: Date): Date {
  const ptParts = new Intl.DateTimeFormat("en-CA", {
    timeZone: PT_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(from)
  const get = (t: string) => ptParts.find((p) => p.type === t)?.value ?? "0"
  const y = parseInt(get("year"), 10)
  const m = parseInt(get("month"), 10) - 1
  const d = parseInt(get("day"), 10)
  const hr = parseInt(get("hour"), 10)
  const min = parseInt(get("minute"), 10)

  const ptNoonUtc = new Date(Date.UTC(y, m, d, 12, 0, 0, 0))
  const offsetHours = isPSTDST(ptNoonUtc) ? 7 : 8
  const ptMidnightUtc = new Date(Date.UTC(y, m, d, offsetHours, 0, 0, 0))
  let dayOfWeek = ptMidnightUtc.getUTCDay()
  let daysAdd = 7 - dayOfWeek
  if (daysAdd === 7) daysAdd = 0
  if (daysAdd === 0 && (hr > AUCTION_END_HOUR || (hr === AUCTION_END_HOUR && min >= AUCTION_END_MINUTE))) daysAdd = 7
  const sundayY = y
  const sundayM = m
  const sundayD = d + daysAdd
  const sundayDate = new Date(Date.UTC(sundayY, sundayM, sundayD, 12, 0, 0, 0))
  const off = isPSTDST(sundayDate) ? 7 : 8
  const utcHour = (AUCTION_END_HOUR + off) % 24
  const utcDayAdd = AUCTION_END_HOUR + off >= 24 ? 1 : 0
  return new Date(Date.UTC(sundayY, sundayM, sundayD + utcDayAdd, utcHour, AUCTION_END_MINUTE, 0, 0))
}

export function computeAuctionEndAt(publishAt: Date): Date {
  const from = new Date(publishAt)

  // Dev override: AUCTION_DEV_DURATION_MINUTES sets end to "now + N minutes".
  // Only active outside production to prevent accidental use in live environment.
  if (process.env.NODE_ENV !== "production" && process.env.AUCTION_DEV_DURATION_MINUTES) {
    const minutes = Number(process.env.AUCTION_DEV_DURATION_MINUTES)
    if (Number.isFinite(minutes) && minutes > 0) {
      console.warn(
        `[auction-timing] DEV OVERRIDE: AUCTION_DEV_DURATION_MINUTES=${minutes} — ` +
          `end time set to now + ${minutes} min instead of next Sunday 7:30pm PT`
      )
      return new Date(from.getTime() + minutes * 60 * 1000)
    }
  }

  let end = nextSunday730PtAfter(from)
  if (end.getTime() - from.getTime() < MIN_DURATION_MS) {
    const nextWeek = new Date(end.getTime() + 1)
    end = nextSunday730PtAfter(nextWeek)
  }
  return end
}

export function formatAuctionEndCopy(endAt: Date): string {
  return new Intl.DateTimeFormat("en-US", {
    timeZone: PT_TZ,
    weekday: "long",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  }).format(endAt)
}

export function getAuctionEndDisplay(endAt: string): string {
  return formatAuctionEndCopy(new Date(endAt))
}
